import { render } from "./Posts.vue?vue&type=template&id=8da6017a&ts=true"
import script from "./Posts.vue?vue&type=script&lang=ts"
export * from "./Posts.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__